import { getSystemList } from "@iewccouk/Services/OrderService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Select, { SelectProps } from "@insite/mobius/Select";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    return {
        parameter: state.pages.orderHistory.getOrdersParameter,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistorySearchFieldShipToStyles {
    select?: SelectProps;
    wrapper?: SearchFieldWrapperStyles;
}

export const shipToStyles: OrderHistorySearchFieldShipToStyles = {};
const styles = shipToStyles;

function OrderHistorySearchFieldShipTos({ updateSearchFields, parameter }: Props) {
    const [options, setOptions] = React.useState([] as any[]);
    const handleChange = (event: React.FormEvent<HTMLSelectElement>) => {
        if (event.currentTarget.value) {
            updateSearchFields({ orderType: event.currentTarget.value } as any);
        } else {
            updateSearchFields({ orderType: undefined } as any);
        }
    };

    const getOptions = async () => {
        const listValues = (await getSystemList({ namelist: "OrderType" })) as any;
        setOptions(listValues?.SystemList?.map?.((x: any) => ({ label: x.Description, value: x.Name })) || []);
    };

    React.useEffect(() => {
        getOptions();
    }, []);

    const value = (parameter as any).orderType ?? "";

    return (
        <SearchFieldWrapper extendedStyles={styles.wrapper}>
            <Select
                label={translate("Order Type")}
                {...styles.select}
                value={value}
                onChange={handleChange}
                placeholder={translate("Select")}
                data-test-selector="orderHistory_filterShipTo"
            >
                <option value="">{translate("Select")}</option>
                {options.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Select>
        </SearchFieldWrapper>
    );
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistorySearchFieldShipTos as any) as any,
    definition: {
        group: "Order History",
        displayName: "Order ype",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
